// extracted by mini-css-extract-plugin
module.exports = {"footerWrap":"style_footerWrap__qgIl+","tip":"style_tip__RC8mo","shieldLogo":"style_shieldLogo__SMgEQ","container":"style_container__Wd7tP","logoLink":"style_logoLink__VHnWo"};